module.exports = __webpack_public_path__ + "static/media/cheeseburger.fe8c05c8.svg";